export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const DELETE_FROM_CART = "DELETE_FROM_CART";
export const UPDATE_CART = "UPDATE_CART";
export const ADD_PROMO_CODE = 'ADD_PROMO_CODE';
export const CHECK_PROMOTION = "CHECK_PROMOTION";
export const CHECK_PROMOTION_ERR = "CHECK_PROMOTION_ERR";
export const CREATE_ORDER = "CREATE_ORDER";
export const CREATE_ORDER_CHAT = "CREATE_ORDER_CHAT";
export const UPDATE_PAYMENT = "UPDATE_PAYMENT";
export const UPDATE_PAYMENT_ERR = "UPDATE_PAYMENT_ERR";
export const PAY_CREDITCARD = "PAY_CREDITCARD";
export const CHANGE_QTY = "CHANGE_QTY";

export const GET_CART = "GET_CART";
export const CART_PROCESS = "CART_PROCESS";
export const CART_PROCESS_ERR = "CART_PROCESS_ERR";

export const GET_ORDER_RESPONSE = "GET_ORDER_RESPONSE";
export const GET_ORDER_RESPONSE_ERR = "GET_ORDER_RESPONSE_ERR";

export const GET_PRO_ERR = "GET_PRO_ERR";
export const CLEAR_COUPON_CODE = "CLEAR_COUPON_CODE";
export const CLEAR_COUPON_ERR_MSG = "CLEAR_COUPON_ERR_MSG";

export const DISPLAY_FREE_ITEM_POPUP = "DISPLAY_FREE_ITEM_POPUP";

//Affiliate
export const ADD_TO_BLOGGER_CART = "ADD_TO_BLOGGER_CART";
export const CHANGE_BLOGGER_CART_QTY = "CHANGE_BLOGGER_CART_QTY";
export const DELETE_FROM_BLOGGER_CART = "DELETE_FROM_BLOGGER_CART";